import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Dialog, DialogPanel } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { useLocation } from 'react-router-dom';
import { Popover, PopoverButton, PopoverPanel, PopoverGroup } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

const solutions = [
    {
        name: 'CueWorkz',
        description: 'Fueling your AI success.',
        href: '/cueworkz',
        icon: '/assets/images/CueWORKZ.png',
    },
    {
        name: 'CLIMB',
        description: 'Step up your brand`s visibility.',
        href: '/climb',
        icon: '/assets/images/Climb.png',
    },
];

const services = [
    {
        name: 'AI-Solutions',
        description:
            'Unleashing the Power of AI and ML. Your Data, Our Solutions—Unleash the Future.',
        href: 'ai-solutions',
        icon: '/assets/services/artificial.png',
    },
    {
        name: 'DevOps Consulting',
        description: 'Expert DevOps for Fast, Reliable Results. Streamline, Automate, Succeed.',
        href: '/devops-consulting',
        icon: '/assets/services/devops.png',
    },
    {
        name: 'UI/UX-Human Cantric Design',
        description:
            'Transforming Websites, Elevating Brands. Revamp Your Website, Revitalize Your Business.',
        href: '/website-design-redesign',
        icon: '/assets/services/Website-DesignRedesign.png',
    },
    {
        name: 'Android & iOS App Development',
        description:
            'Bringing Ideas to Life with Perfect Apps—Affordable and Ready for a Mobile-First World.',
        href: '/android-ios-app-development',
        icon: '/assets/services/Android-iOS-App-Development.png',
    },
    {
        name: 'Custom Software Development',
        description: 'Tailored Solutions for Every Industry. Your Vision, Our Code.',
        href: '/custom-software-development',
        icon: '/assets/services/Custom-Software-Development.png',
    },
    {
        name: 'E-Commerce & CMS Development',
        description: 'Simplifying Content Management and empowering Your Online Store.',
        href: '/e-commerce-cms',
        icon: '/assets/services/E-Commerce-CMS-Platforms.png',
    },
];

const products = [
    {
        name: 'CueWORKZ ',
        href: '/cueworkz',
    },
    {
        name: 'CLIMB',
        href: '/climb',
    },
];
const Header = () => {
    const location = useLocation();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isProductsOpen, setIsProductsOpen] = useState(false);
    const toggleServices = () => {
        setIsServicesOpen((prev) => !prev);
        setIsProductsOpen(false);
    };

    const toggleProducts = () => {
        setIsProductsOpen((prev) => !prev);
        setIsServicesOpen(false);
    };

    const popoverRef = useRef(null);
    const hideContactUsButton = location.pathname === '/cueworkz' || location.pathname === '/climb';
    const getLogo = () => {
        switch (location.pathname) {
            case '/cueworkz':
                return { src: '/assets/images/CueWORKZ.png', width: '200px', height: '50px' };
            case '/climb':
                return { src: '/assets/images/Climb.png', width: '180px', height: '45px' };
            default:
                return { src: '/assets/images/cueverz-logo.png', width: '160px', height: '40px' }; // Default home logo
        }
    };
    const logoData = getLogo();
    const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setIsServicesOpen(false);
            setIsProductsOpen(false);
        }
    };

    useEffect(() => {
        if (isServicesOpen || isProductsOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isServicesOpen, isProductsOpen]);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    useEffect(() => {
        if (location.hash) {
            const element = document.querySelector(location.hash);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);
    // Check the hash on page load
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location.hash]);
    return (
        <motion.header
            initial={{ y: -40, opactiy: 0 }}
            animate={{ y: 0, opactiy: 1 }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
            className='sticky top-0 inset-x-0  z-40 text-white md:mx-10'
        >
            <nav
                aria-label='Global'
                className={`flex items-center justify-between p-3 lg:px-8 m-auto  z-50 relative border${
                    scrolled
                        ? 'backdrop-blur-xl bg-white/10 border border-white/25 rounded-lg'
                        : 'bg-transparent'
                } md:max-w-3xl lg:max-w-6xl ${mobileMenuOpen ? 'hidden' : ''}`}
            >
                <div className='flex lg:flex-1'>
                    <a href='/' className='-m-1.5 p-1.5 focus:outline-none' aria-label='Cueverz'>
                        <span className='sr-only'>Cueverz</span>
                        <img
                            alt='Cueverz - Leading the Way in Software Innovation, Web development, software development, california, best website development company in 2025.'
                            title='Cueverz - Leading the Way in Software Innovation'
                            src={logoData.src}
                            className='lg:h-16 h-10 w-auto'
                        />
                    </a>
                </div>
                <div className='flex lg:hidden'>
                    <button
                        type='button'
                        onClick={() => setMobileMenuOpen(true)}
                        className='-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 '
                    >
                        <span className='sr-only'>Open main menu</span>
                        <Bars3Icon aria-hidden='true' className='h-6 w-6' />
                    </button>
                </div>
                <PopoverGroup
                    ref={popoverRef}
                    className='hidden lg:flex lg:gap-x-12 text-white items-center'
                >
                    <a
                        href='/'
                        className='text-lg font-light leading-6 focus:outline-none'
                        aria-label='Go to homepage'
                    >
                        Home
                    </a>
                    <Dropdown
                        label='Services'
                        items={services}
                        isOpen={isServicesOpen}
                        toggleDropdown={toggleServices}
                        customCss1='grid grid-cols-2'
                        customCss2='max-w-2xl'
                    />
                    <Dropdown
                        label='Products'
                        items={solutions}
                        isOpen={isProductsOpen}
                        toggleDropdown={toggleProducts}
                        customCss2='max-w-fit'
                    />
                    <a
                        href='/about-us'
                        className='text-lg font-light leading-6 focus:outline-none'
                        aria-label='ABOUT'
                    >
                        About
                    </a>
                    {!hideContactUsButton && (
                        <a
                            href='/contact-us'
                            className='text-lg font-light leading-6 focus:outline-none'
                            aria-label='Contact Us'
                        >
                            Contact Us
                        </a>
                    )}

                    <a
                        href='/book-a-call'
                        className=' btn-primary  bg-white text-black focus:outline-none'
                        aria-label='Book A Call'
                    >
                        Book a Call
                    </a>
                </PopoverGroup>
            </nav>
            <Dialog
                open={mobileMenuOpen}
                onClose={setMobileMenuOpen}
                className='lg:hidden relative text-white'
            >
                <div className='fixed inset-0 z-10' />
                <DialogPanel className='fixed inset-y-0 right-0 z-10 w-full overflow-y-auto backdrop-blur-lg bg-white/10 border border-white/25 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10 '>
                    <div className='flex items-center justify-between'>
                        <a href='/' className='-m-1.5 p-1.5' aria-label='cueverz'>
                            <span className='sr-only'>Cueverz</span>
                            <img
                                src='/assets/images/cueverz-logo.png'
                                className='h-8 w-auto'
                                alt='Cueverz - Leading the Way in Software Innovation, Web development, software development, california, best website development company in 2025.'
                                title='Cueverz - Leading the Way in Software Innovation'
                            />
                        </a>
                        <button
                            type='button'
                            onClick={() => setMobileMenuOpen(false)}
                            className='-m-2.5 rounded-md p-2.5 text-white'
                        >
                            <span className='sr-only'>Close menu</span>
                            <XMarkIcon aria-hidden='true' className='h-6 w-6' />
                        </button>
                    </div>
                    <div className='mt-6 flow-root'>
                        <div className='-my-6 divide-y divide-gray-500/10'>
                            <div className='space-y-2 py-6'>
                                <a
                                    href='/'
                                    aria-label='Home'
                                    className='-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 '
                                >
                                    Home
                                </a>

                                <Disclosure as='div' className='-mx-3'>
                                    <DisclosureButton className='group flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7'>
                                        Services
                                        <ChevronDownIcon
                                            aria-hidden='true'
                                            className='h-5 w-5 flex-none group-data-[open]:rotate-180'
                                        />
                                    </DisclosureButton>
                                    <DisclosurePanel className='mt-2 space-y-2'>
                                        {[...services].map((item) => (
                                            <DisclosureButton
                                                key={item.name}
                                                as='a'
                                                href={item.href}
                                                className='block py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-center  border-b border-white/30'
                                            >
                                                {item.name}
                                            </DisclosureButton>
                                        ))}
                                    </DisclosurePanel>
                                </Disclosure>
                                <Disclosure as='div' className='-mx-3'>
                                    <DisclosureButton className='group flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7'>
                                        Products
                                        <ChevronDownIcon
                                            aria-hidden='true'
                                            className='h-5 w-5 flex-none group-data-[open]:rotate-180'
                                        />
                                    </DisclosureButton>
                                    <DisclosurePanel className='mt-2 space-y-2'>
                                        {[...products].map((item) => (
                                            <DisclosureButton
                                                key={item.name}
                                                as='a'
                                                href={item.href}
                                                className='block py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-center  border-b border-white/30'
                                            >
                                                {item.name}
                                            </DisclosureButton>
                                        ))}
                                    </DisclosurePanel>
                                </Disclosure>
                                <a
                                    href='/about-us'
                                    aria-label='About'
                                    className='-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 '
                                >
                                    About
                                </a>
                                <div className='py-5'>
                                    <a
                                        href='/contact-us'
                                        className=' btn-primary  bg-transparent text-white border border-white w-full block text-center'
                                        aria-label='Contact Us'
                                    >
                                        Contact Us
                                    </a>
                                </div>
                                <a
                                    href='/book-a-call'
                                    aria-label='Book A Call'
                                    className='btn-primary  bg-white text-black w-full block text-center'
                                >
                                    Book a Call
                                </a>
                            </div>
                        </div>
                    </div>
                </DialogPanel>
            </Dialog>
        </motion.header>
    );
};

export default Header;

const Dropdown = ({ label, items, isOpen, toggleDropdown, customCss1, customCss2, scrolled }) => (
    <Popover className='relative z-50'>
        <PopoverButton
            onClick={toggleDropdown}
            className={`inline-flex items-center gap-x-1 text-lg leading-6 focus:outline-none ${
                isOpen ? 'font-bold' : 'font-light'
            }`}
        >
            <span>{label}</span>
            <ChevronDownIcon aria-hidden='true' className='h-5 w-5' />
        </PopoverButton>

        {isOpen && (
            <PopoverPanel
                transition
                className={`absolute left-1/2 mt-10 z-10 flex w-screen max-w-max -translate-x-1/2 px-4 backdrop-blur-3xl bg-white/10 border border-white/25 shadow-lg rounded-lg ${
                    scrolled
                        ? 'backdrop-blur-sm bg-white/10 border border-white/25 rounded-lg'
                        : 'bg-transparent'
                }`}
            >
                <div className={` w-screen ${customCss2} flex-auto rounded-3xl text-sm `}>
                    <div className={`p-4 ${customCss1}`}>
                        {items.map((item) => (
                            <a
                                key={item.name}
                                href={item.href}
                                className='group flex gap-x-6 rounded-lg py-4'
                            >
                                <img src={item.icon} alt={item.description} className='h-14' />
                                <div>
                                    <p className='font-semibold'>{item.name}</p>
                                    <p className='text-xs'>{item.description}</p>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </PopoverPanel>
        )}
    </Popover>
);
